var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "mobileBackground", staticClass: "mobile-background" },
    [
      _c("div", { staticClass: "mobile-content-container" }, [
        _c(
          "div",
          {
            staticClass: "upper-container",
            on: {
              click: function($event) {
                return _vm.redirectToDrc()
              }
            }
          },
          [
            _c("div", { staticClass: "landing-content" }, [
              _c("h1", [_vm._v(_vm._s(_vm.$t("landingPage.drc")))]),
              _c("div", { staticClass: "landing-text" }, [
                _vm._v(_vm._s(_vm.$t("landingPage.drcDescription")))
              ]),
              _c("button", { staticClass: "example" }, [
                _vm._v(_vm._s(_vm.$t("landingPage.exploreDrc").toUpperCase()))
              ])
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "lower-container",
            on: {
              click: function($event) {
                return _vm.redirectToGop()
              }
            }
          },
          [
            _c("div", { staticClass: "landing-content" }, [
              _c("h1", [_vm._v(_vm._s(_vm.$t("landingPage.gop")))]),
              _c("div", { staticClass: "landing-text" }, [
                _vm._v(_vm._s(_vm.$t("landingPage.gopDescription")))
              ]),
              _c("button", [
                _vm._v(_vm._s(_vm.$t("landingPage.exploreGop").toUpperCase()))
              ])
            ])
          ]
        )
      ]),
      _c("Newsletter")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }